/* SOLENE: animaciones e interacciones de la portada (sin librerias externas). */
(function () {
  var reducido = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var observador = null;

  /* Titulares que aparecen palabra a palabra. */
  function initPalabras(raiz) {
    raiz.querySelectorAll('[data-ig-palabras]:not([data-ig-listo])').forEach(function (el) {
      el.setAttribute('data-ig-listo', '');
      var i = 0;
      (function partir(nodo) {
        Array.prototype.slice.call(nodo.childNodes).forEach(function (hijo) {
          if (hijo.nodeType === 3) {
            var frag = document.createDocumentFragment();
            hijo.textContent.split(/(\s+)/).forEach(function (trozo) {
              if (!trozo) return;
              if (/^\s+$/.test(trozo)) { frag.appendChild(document.createTextNode(' ')); return; }
              var fuera = document.createElement('span');
              fuera.className = 'ig-palabra';
              var dentro = document.createElement('span');
              dentro.style.setProperty('--i', i++);
              dentro.textContent = trozo;
              fuera.appendChild(dentro);
              frag.appendChild(fuera);
            });
            nodo.replaceChild(frag, hijo);
          } else if (hijo.nodeType === 1 && hijo.tagName !== 'BR') {
            partir(hijo);
          }
        });
      })(el);
    });
  }

  /* Entradas al hacer scroll. */
  function initReveal(raiz) {
    var els = raiz.querySelectorAll('.ig-reveal:not(.ig-visible), .ig-reveal-img:not(.ig-visible), [data-ig-palabras]:not(.ig-visible)');
    if (reducido || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('ig-visible'); });
      return;
    }
    if (!observador) {
      observador = new IntersectionObserver(function (entradas) {
        entradas.forEach(function (e) {
          if (!e.isIntersecting) return;
          var t = e.target;
          if (t.classList.contains('ig-reveal') || t.classList.contains('ig-reveal-img') || t.hasAttribute('data-ig-palabras')) t.classList.add('ig-visible');
          (t.igFotos || []).forEach(function (foto) { foto.classList.add('ig-visible'); });
          t.igFotos = [];
          observador.unobserve(t);
        });
      }, { threshold: 0.08, rootMargin: '0px 0px -6% 0px' });
    }
    els.forEach(function (el) {
      /* Las fotos que se "descubren" empiezan recortadas del todo, y un elemento recortado
         nunca cuenta como visible: por eso se vigila a su contenedor y no a la foto. */
      if (el.classList.contains('ig-reveal-img') && el.parentElement) {
        var caja = el.parentElement;
        caja.igFotos = caja.igFotos || [];
        caja.igFotos.push(el);
        observador.observe(caja);
      } else {
        observador.observe(el);
      }
    });
    /* Red de seguridad: si algo falla, a los 4 segundos se muestra todo. */
    setTimeout(function () {
      raiz.querySelectorAll('.ig-reveal-img:not(.ig-visible)').forEach(function (el) {
        var c = el.getBoundingClientRect();
        if (c.top < window.innerHeight && c.bottom > 0) el.classList.add('ig-visible');
      });
    }, 4000);
  }

  /* Segunda comprobación para las fotos, por posición en pantalla (no depende del recorte). */
  var fotosPendiente = false;
  function revisarFotos() {
    fotosPendiente = false;
    var alto = window.innerHeight;
    document.querySelectorAll('.ig-reveal-img:not(.ig-visible)').forEach(function (el) {
      var c = el.getBoundingClientRect();
      if (c.top < alto * 0.92 && c.bottom > 0) el.classList.add('ig-visible');
    });
  }
  window.addEventListener('scroll', function () {
    if (!fotosPendiente) { fotosPendiente = true; requestAnimationFrame(revisarFotos); }
  }, { passive: true });
  window.addEventListener('load', revisarFotos);

  /* Parallax suave dentro de las tarjetas con foto de fondo. */
  var capas = [];
  var pendiente = false;
  function moverParallax() {
    pendiente = false;
    var alto = window.innerHeight;
    capas = capas.filter(function (el) { return document.body.contains(el); });
    capas.forEach(function (el) {
      var caja = el.parentElement.getBoundingClientRect();
      if (caja.bottom < -100 || caja.top > alto + 100) return;
      var centro = (caja.top + caja.height / 2 - alto / 2) / alto;
      var fuerza = parseFloat(el.getAttribute('data-ig-parallax')) || 0.1;
      el.style.transform = 'translate3d(0,' + (centro * fuerza * -100).toFixed(2) + 'px,0)';
    });
  }
  function initParallax(raiz) {
    if (reducido) return;
    raiz.querySelectorAll('[data-ig-parallax]').forEach(function (el) {
      if (capas.indexOf(el) === -1) capas.push(el);
    });
    moverParallax();
  }
  window.addEventListener('scroll', function () {
    if (!pendiente && capas.length) { pendiente = true; requestAnimationFrame(moverParallax); }
  }, { passive: true });

  /* Inclinacion 3D sutil al pasar el cursor. */
  function initTilt(raiz) {
    if (reducido || !window.matchMedia('(hover: hover)').matches) return;
    raiz.querySelectorAll('[data-ig-tilt]:not([data-ig-listo])').forEach(function (el) {
      el.setAttribute('data-ig-listo', '');
      var max = parseFloat(el.getAttribute('data-ig-tilt')) || 5;
      el.addEventListener('mousemove', function (ev) {
        var c = el.getBoundingClientRect();
        var x = (ev.clientX - c.left) / c.width - 0.5;
        var y = (ev.clientY - c.top) / c.height - 0.5;
        el.style.transform = 'perspective(900px) rotateY(' + (x * max).toFixed(2) + 'deg) rotateX(' + (-y * max).toFixed(2) + 'deg) translateY(-6px)';
      });
      el.addEventListener('mouseleave', function () { el.style.transform = ''; });
    });
  }

  /* Escena fija: la foto cambia segun el paso que esta en pantalla. */
  function initEscena(raiz) {
    raiz.querySelectorAll('[data-ig-escena]:not([data-ig-listo])').forEach(function (escena) {
      escena.setAttribute('data-ig-listo', '');
      var pasos = escena.querySelectorAll('.ig-escena__paso');
      var fotos = escena.querySelectorAll('.ig-escena__visual img');
      var conta = escena.querySelector('[data-ig-conta]');
      var barra = escena.querySelector('.ig-escena__barra i');
      function activar(n) {
        pasos.forEach(function (p, i) { p.classList.toggle('ig-activa', i === n); });
        fotos.forEach(function (f, i) { f.classList.toggle('ig-activa', i === n); });
        if (conta) conta.textContent = ('0' + (n + 1)).slice(-2) + ' / ' + ('0' + pasos.length).slice(-2);
        if (barra) barra.style.setProperty('--p', (n + 1) / pasos.length);
      }
      activar(0);
      if (!('IntersectionObserver' in window)) return;
      var obs = new IntersectionObserver(function (entradas) {
        entradas.forEach(function (e) {
          if (e.isIntersecting) activar(Array.prototype.indexOf.call(pasos, e.target));
        });
      }, { rootMargin: '-45% 0px -45% 0px', threshold: 0 });
      pasos.forEach(function (p) { obs.observe(p); });
    });
  }

  /* Números que cuentan desde cero al entrar en pantalla. */
  function initCifras(raiz) {
    raiz.querySelectorAll('[data-ig-cuenta]:not([data-ig-listo])').forEach(function (el) {
      el.setAttribute('data-ig-listo', '');
      var fin = parseFloat(el.getAttribute('data-ig-cuenta')) || 0;
      var dur = parseInt(el.getAttribute('data-duracion'), 10) || 1600;
      if (reducido || !('IntersectionObserver' in window)) return;
      el.textContent = '0';
      var obs = new IntersectionObserver(function (entradas) {
        if (!entradas[0].isIntersecting) return;
        obs.disconnect();
        var inicio = null;
        function paso(t) {
          if (inicio === null) inicio = t;
          var p = Math.min(1, (t - inicio) / dur);
          var suave = 1 - Math.pow(1 - p, 3);
          el.textContent = Math.round(fin * suave);
          if (p < 1) requestAnimationFrame(paso);
        }
        requestAnimationFrame(paso);
      }, { threshold: 0.4 });
      obs.observe(el);
    });
  }

  /* Buscador de seguimiento: abre la web de seguimiento con el número escrito. */
  function initSeguimiento(raiz) {
    raiz.querySelectorAll('[data-ig-seguimiento]:not([data-ig-listo])').forEach(function (form) {
      form.setAttribute('data-ig-listo', '');
      var campo = form.querySelector('input');
      var aviso = form.querySelector('.ig-seg__error');
      form.addEventListener('submit', function (ev) {
        ev.preventDefault();
        var numero = (campo.value || '').replace(/\s+/g, '');
        if (!numero) {
          if (aviso) aviso.hidden = false;
          campo.focus();
          return;
        }
        if (aviso) aviso.hidden = true;
        var destino = form.getAttribute('data-destino') || 'https://t.17track.net/es#nums={numero}';
        window.open(destino.replace('{numero}', encodeURIComponent(numero)), '_blank', 'noopener');
      });
    });
  }

  /* Desplegables de preguntas frecuentes. */
  function initAcordeon(raiz) {
    raiz.querySelectorAll('.ig-faq__q:not([data-ig-listo])').forEach(function (boton) {
      boton.setAttribute('data-ig-listo', '');
      boton.addEventListener('click', function () {
        var abierto = boton.getAttribute('aria-expanded') === 'true';
        var grupo = boton.closest('[data-ig-acordeon]');
        if (grupo && grupo.getAttribute('data-ig-acordeon') === 'uno') {
          grupo.querySelectorAll('.ig-faq__q[aria-expanded="true"]').forEach(function (otro) {
            if (otro !== boton) otro.setAttribute('aria-expanded', 'false');
          });
        }
        boton.setAttribute('aria-expanded', abierto ? 'false' : 'true');
      });
    });
  }

  function init(raiz) {
    raiz = raiz || document;
    initPalabras(raiz);
    initReveal(raiz);
    initParallax(raiz);
    initTilt(raiz);
    initEscena(raiz);
    initAcordeon(raiz);
    initCifras(raiz);
    initSeguimiento(raiz);
    document.dispatchEvent(new CustomEvent('ig:init', { detail: raiz }));
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }
  /* En el editor de Shopify las secciones se recargan sueltas: se vuelven a activar. */
  document.addEventListener('shopify:section:load', function (ev) { init(ev.target); });
})();
